module.exports = __webpack_public_path__ + "img/Pattern05.21285a97.png";